import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'semantic-ui-react';


// export default class RenderField extends Component {
//   static propTypes = {

//   };

//   render() {
//     return (
//       <div className="common-render-field">
//         Component content: common/RenderField
//       </div>
//     );
//   }
// }



const renderField = ({
  input, label, type, meta: { touched, error }, id, ...restProps,
}) => (
    <Form.Field >
      <label>{label}</label>
      {touched && error && <div style={{ color: 'red', marginBottom: '0.5em' }}>{error}</div>}
      <Input {...input} id={id} fluid type={type} placeholder={label} {...restProps} />
    </Form.Field>
  );

renderField.defaultProps = {
  id: null,
  type: '',
};
renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  meta: PropTypes.shape().isRequired,
  id: PropTypes.string,
};

export default renderField;



// WEBPACK FOOTER //
// ./src/features/common/RenderField.js